import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetPublicHolidayRegions,
  CreatePublicHolidayRegion,
  SavePublicHolidayRegion,
  DeletePublicHolidayRegion,
  ExportPublicHolidayRegions,
  ImportPublicHolidayRegions
}

function GetPublicHolidayRegions(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/ressourcecalendar/publicholidayregions`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function CreatePublicHolidayRegion(
  publicholidayRegionObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/ressourcecalendar/publicholidayregions`,
      publicholidayRegionObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function SavePublicHolidayRegion(
  publicholidayRegionId,
  publicholidayRegionObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + `/ressourcecalendar/publicholidayregions/${publicholidayRegionId}`,
      publicholidayRegionObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function DeletePublicHolidayRegion(publicholidayRegionId, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL + `/ressourcecalendar/publicholidayregions/${publicholidayRegionId}`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function ExportPublicHolidayRegions(onSuccess, onError) {
    var headers = getAuthHeader();
    axios
      .get(
        process.env.VUE_APP_BASE_API_URL + `/ressourcecalendar/exportpublicholidayregions`,
        headers
      )
      .then(response => {
        onSuccess(response.data);
      })
      .catch(error => {
        onError(error);
      });
}

function ImportPublicHolidayRegions(publicHolidayRegions, onSuccess, onError) {
    var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/ressourcecalendar/importpublicholidayregions`,
      publicHolidayRegions,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}